export enum UserPermission {
  CREATE_PD_SESSION = 'pdCreateSession',
  PD_FACILITATOR = 'pdFacilitator',
}

export interface UserAssignedPermissionDTO {
  pdCreateSession: number;
  pdFacilitator: number;
}
